<div class="main-container">
    <div class="table-filter-container" #filter>
        <div class="table-filter-wrapper">
            <div class="table-filter">
                <span class="label">{{commonData.Filter_Popup_Label | translate}}</span>
                <span class="count" *ngIf="!configData.showCount">{{tempValCount}}</span>
                <span class="search-applied">{{filterName}}</span>
                <span *ngFor="let data of configData?.filterActions">
                    <button type="{{data.view.type}}" class="clear-button btn clear-button-top " *ngIf="data.view.buttonType === 'clear'" (click)="clearFilters($event)">
                        {{data.view.label | translate }}
                    </button>
                </span>
            </div>
            <div>
                <button [ngClass]="{opened: showFilters}" class="secondary" (mouseup)="openFilterOptions($event)">
                    <span [ngClass]="{up: showFilters}" class="arrow"></span>
                    <span>{{ showFilters ? 'Show Less' : 'Show More' }}</span>
                </button>
            </div>
        </div>
        <div [ngStyle]="{'display': showFilters ? 'block' : 'none'}" class="all-filters">
            <!-- <div class="section">
                <div class="title">Saved Searches</div>
                <div class="nodata">No Saved Searches</div>
            </div> -->
            <app-form (form)="getForm($event)" [configData]=configData></app-form>
            <div class="actions">
                <span *ngFor="let data of configData?.filterActions">
                    <button type="{{data.view.type}}" class="dhl-button-v2 buttons-ghost-small-v2" *ngIf="data.view.buttonType === 'clear'" (click)="clearFilters($event)">
                        {{data.view.label | translate }}
                    </button>
                    <button type="{{data.view.type}}" class="dhl-button-v2 buttons-secondary-small-v2" [disabled] ="disableSave" *ngIf="data.view.buttonType === 'secondary'" (click)="saveAndApplySearchFilters(data,$event, 'save')">
                        {{data.view.label | translate }}
                    </button>
                    <button type="{{data.view.type}}" class="dhl-button-v2 buttons-primary-small-v2" *ngIf="data.view.buttonType === 'primary'" (click)="saveAndApplySearchFilters(data, $event,'apply')" >
                        {{data.view.label | translate }}
                    </button>
                </span>
            </div>
        </div>
    </div>
</div>